export default __webpack_public_path__ + "static/media/discover2.21bd80a1.png";